import React, { useState, useEffect } from 'react';
import image4 from '../assets/images/image4.png';
import { MyButton } from './ui/MyButton.js';
import BenefitsSection from './ui/BenefitsSection.js';
import { benefitsOfMobileApp, mobileAppOptions } from '../constant.js';
import { useNavigate } from "react-router-dom";
import ScrollAnimation from 'react-animate-on-scroll';

const ServicesMobileApp = () => {
    const navigate = useNavigate();
    const [activeOption, setActiveOption] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className='animated_card'>
            <div className={`${isMobile ? "sizedbox" : ""} row g-2 gap-2 justify-content-end mt-5`}>
                <ScrollAnimation animateIn='fadeInLeft' className='col-12 col-md-6'
                    animateOut='fadeOutLeft' initiallyVisible="true">
                    <div style={{ paddingLeft: !isMobile ? "5%" : "0" }}>
                        <h2 style={{ color: "var(--text-color)" }}>
                            <span
                                style={{
                                    background: "var(--primary-gradient-100)",
                                    backgroundClip: "text",
                                    WebkitTextFillColor: "transparent"
                                }}>Mobile Application </span> <br />for Koha LMS
                        </h2>
                        <p style={{ fontSize: "18px", fontWeight: "400", color: "var(--text-color)", lineHeight: "24px", marginBottom: "30px", width: "80%" }}>
                            Our Koha LMS Mobile Application revolutionizes library management by leveraging advanced technology to provide seamless accessibility and exceptional user engagement. Featuring an intuitive design and state-of-the-art functionality, users can effortlessly navigate the library's catalogue, explore detailed book information with accompanying images, and check availability—all on the go. By integrating modern tools and a user-focused design, our app ensures a more efficient, innovative, and engaging library experience.
                        </p>
                        <div className='mt-auto'>
                            <MyButton btntext="Contact Us" onClick={() => { navigate("/contact") }} />
                        </div>
                    </div>
                </ScrollAnimation>
                <ScrollAnimation animateIn='fadeInRight' className='col-12 col-md-5'
                    animateOut='fadeOutRight' initiallyVisible="true">
                    <div>
                        <img src={image4} alt='Mobile App' style={{ width: "100%", height: "auto", maxHeight: "500px", borderRadius: isMobile ? "20px" : "" }}></img>
                    </div>
                </ScrollAnimation>
            </div>
            <div className='mt-5'>
                <BenefitsSection title="Features of Mobile Application" list={benefitsOfMobileApp} />
            </div>
            <div className='mt-5 p-4 text-center' style={{ backgroundImage: "linear-gradient(0, white  0 50%, #EBF1FD 50% 100%)" }}>
                <h2 style={{ color: "var(--text-color)" }}>
                    Options for&nbsp;
                    <span
                        style={{
                            background: "var(--primary-gradient-100)",
                            backgroundClip: "text",
                            WebkitTextFillColor: "transparent"
                        }}>Mobile Application</span>
                </h2>
                <div className='mt-4 d-flex flex-wrap gap-4 justify-content-center' style={{ margin: "50px 0", }}>
                    {
                        mobileAppOptions.map((item, index) => (
                            <div className={`options-card ${activeOption === index ? "active" : ""}`}
                                onMouseEnter={() => setActiveOption(index)}
                                style={{ background: activeOption === index ? "var(--primary-gradient-100)" : "transparent", borderRadius: "20px", padding: "2px" }}>
                                <div style={{ backgroundColor: "#F7F6FF", borderRadius: "18px", padding: "30px", boxShadow: "0px 4px 5px 0px #00000033", height: "100%" }}>
                                    {
                                        activeOption === index ? <p
                                            style={
                                                {
                                                    fontSize: "30px", fontWeight: "400", lineHeight: "42px",
                                                    background: "var(--primary-gradient-100)",
                                                    backgroundClip: "text",
                                                    WebkitTextFillColor: "transparent"
                                                }
                                            }>{item.title}</p>
                                            : <p
                                                style={
                                                    {
                                                        fontSize: "30px", fontWeight: "400", lineHeight: "42px", color: "#848489"
                                                    }
                                                }>{item.title}</p>
                                    }

                                    <img style={{ maxWidth: "300px" }} src={item.image} alt={item.title}></img>
                                    <div className='mt-4'>
                                        {
                                            item.steps.map((step, index) => (
                                                <div className='d-flex gap-2 mt-2'>
                                                    <div className='rounded-circle text-center align-items-center align-content-center' style={{ width: "30px", height: "30px", background: "var(--primary-gradient-10)" }}>
                                                        <p className='m-auto' style={{ fontSize: "16px", fontWeight: "400", lineHeight: "18px" }}>{index + 1}</p></div>
                                                    <h3 style={{ fontSize: "20px", fontWeight: "400", lineHeight: "30px" }}>{step}</h3>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
}

export default ServicesMobileApp;